import React from 'react';
import PropTypes from 'prop-types';
import './PageLayout.scss';

import Header from '../Header';
import Footer from '../Footer';

export const PageLayout = ({ store, children }) => (
  <div className='page-layout'>
    <Header store={store} />
    {children}
    <Footer />
  </div>
);

PageLayout.propTypes = {
  children: PropTypes.node,
  store: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/routes/signup/layouts/PageLayout/PageLayout.js